import { createApi } from "@reduxjs/toolkit/query/react";

import { appBaseQuery } from "config/api.config";
import {
  BulkImportFromFileAsyncResponse,
  VerifyImportResponse,
} from "types/upload.types";

export const uploadApi = createApi({
  reducerPath: "upload",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getBulkImportSampleFile: builder.query<string, void>({
      query: () => ({
        url: "BulkImport/GetBulkImportSampleFile",
        async responseHandler(response) {
          return response.text();
        },
      }),
    }),
    verifyImportFile: builder.mutation<VerifyImportResponse, FormData>({
      query: (formData) => ({
        method: "POST",
        url: "BulkImport/VerifyImportFile",
        body: formData,
      }),
    }),
    bulkImportFromFileAsync: builder.mutation<
      BulkImportFromFileAsyncResponse,
      FormData
    >({
      query: (formData) => ({
        method: "POST",
        url: "BulkImport/BulkImportFromFileAsync",
        body: formData,
      }),
    }),
  }),
});

export const {
  useLazyGetBulkImportSampleFileQuery,
  useVerifyImportFileMutation,
  useBulkImportFromFileAsyncMutation,
} = uploadApi;
